import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
  },
  // 在开发环境中启用Redux DevTools
  devTools: process.env.NODE_ENV !== 'production',
});

export default store; 